import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var RepeatPipe = (function () {
    function RepeatPipe() {
    }
    RepeatPipe.prototype.transform = function (str, n, separator) {
        if (n === void 0) { n = 1; }
        if (separator === void 0) { separator = ''; }
        if (n <= 0) {
            throw new RangeError();
        }
        return n === 1 ? str : this.repeat(str, n - 1, separator);
    };
    RepeatPipe.prototype.repeat = function (str, n, separator) {
        return isString(str)
            ? (n === 0 ? str : (str + separator + this.repeat(str, n - 1, separator)))
            : str;
    };
    RepeatPipe.decorators = [
        { type: Pipe, args: [{ name: 'repeat' },] },
    ];
    /** @nocollapse */
    RepeatPipe.ctorParameters = function () { return []; };
    return RepeatPipe;
}());
export { RepeatPipe };
//# sourceMappingURL=repeat.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/repeat.js
// module id = 284
// module chunks = 4